import { MatTableDataSourceExtended } from "@comunicare/comunicare-angular-interfaces";
import { Tools } from "@comunicare/comunicare-helper";
import { IAccessGroupPermission } from "@comunicare/comunicare-interfaces";
import { TranslateService } from "@ngx-translate/core";

export class PermissionsListDataSource extends MatTableDataSourceExtended<IAccessGroupPermission> {
  sortingDataAccessor = (data: IAccessGroupPermission, sortHeaderId: string) => {
    switch (sortHeaderId) {
      case "theme":
        return data?.theme;
      case "method":
        return data?.method ? this.translateService.instant("groupPermission." + data.method) : "";
      case "routeName":
        return data?.routeName;
      case "access":
        return data?.access.toString() ? this.translateService.instant("groupPermission." + data?.access.toString()) : "";
      default:
        return "";
    }
  };

  constructor(private translateService: TranslateService) {
    super();
  }

  public loadData(permissions: IAccessGroupPermission[]): void {
    this.data = Tools.deepCopy(permissions);
  }

  public addData(permissions: IAccessGroupPermission[]): void {
    this.data = [...(this.data ?? []), ...(Tools.deepCopy(permissions) ?? [])];
  }
}
